import isFunction from 'lodash/isFunction';
import isString from 'lodash/isString';
const noop = () => { };
const noopLog = {
    checkLevelEnabled: () => false,
    trace: noop,
    debug: noop,
    info: noop,
    warn: noop,
    error: noop,
    fnLogger: () => noopLog,
    idLogger: () => noopLog,
    debugFn: () => noopLog,
    if: () => noopLog,
    debugEnter: noop,
    debugExit: noop,
    debugObject: noop,
    debugVar: noop,
    errorVar: noop,
};
export class ExtendedLogger {
    logger;
    log;
    name;
    constructor(logger, name) {
        this.logger = logger;
        this.name = name;
        this.log = logger(name);
    }
    checkLevelEnabled(level) {
        return this.log.checkLevelEnabled(level);
    }
    fnLogger(fnName) {
        const fnLog = new ExtendedLogger(this.logger, `${this.name}.${fnName}`);
        return fnLog;
    }
    idLogger(label, id) {
        const idLog = new ExtendedLogger(this.logger, `${this.name}|${label}-${id || 'missing'}`);
        return idLog;
    }
    debugFn(fnName, ...args) {
        const fnLog = this.fnLogger(fnName);
        fnLog.debugEnter(...args);
        return fnLog;
    }
    if(predicate) {
        const isLogged = isFunction(predicate) ? predicate() : !!predicate;
        return isLogged ? this : noopLog;
    }
    debugEnter(...args) {
        this.log.debug(`ENTER${args.length > 0 ? ':' : ''}`, ...args);
    }
    debugExit(...args) {
        this.log.debug(`EXIT${args.length > 0 ? ':' : ''}`, ...args);
    }
    debugObject(...args) {
        if (!this.log.checkLevelEnabled('DEBUG')) {
            return;
        }
        const [obj, label] = this.maybeLabeled(args);
        const header = this.labeledHeader(label);
        this.log.debug(`${header}\n${JSON.stringify(obj, null, 2)}\n${header}`);
    }
    debugVar(...args) {
        if (!this.log.checkLevelEnabled('DEBUG')) {
            return;
        }
        const [object, label] = this.maybeLabeled(args);
        if (label) {
            this.log.debug(this.labeledHeader(label));
        }
        for (const [key, val] of Object.entries(object)) {
            this.log.debug(`${key} =`, val);
        }
    }
    errorVar(object) {
        if (!object || !this.log.checkLevelEnabled('ERROR')) {
            return;
        }
        for (const [key, val] of Object.entries(object)) {
            this.log.error(`${key} =`, val);
        }
    }
    trace(...args) {
        this.log.trace(...args);
    }
    debug(...args) {
        this.log.debug(...args);
    }
    error(...args) {
        this.log.error(...args);
    }
    warn(...args) {
        this.log.warn(...args);
    }
    info(...args) {
        this.log.info(...args);
    }
    labeledHeader(header) {
        const paddedHeader = header ? ` ${header} ` : header;
        return `--${paddedHeader}${'-'.repeat(Math.floor((header.length || 58) / 2))}`;
    }
    maybeLabeled(args) {
        const [first, second] = args;
        const haveName = isString(first);
        const label = haveName ? first.trim() : '';
        const value = haveName ? second : first;
        return [value, label];
    }
}
//# sourceMappingURL=extended-logger.js.map